type RatingKey = 1 | 2 | 3 | 4 | 5;
type RatingDistribution = Record<RatingKey, number>;

const RATING_KEYS = [5, 4, 3, 2, 1] as const;

export const getRatingSummary = (
    reviews: any[],
): { stars: number; count: number; percentage: number }[] => {
    const distribution: RatingDistribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach((review) => {
        const rating = review?.rating;
        if (rating >= 1 && rating <= 5) {
            distribution[rating as RatingKey] += 1;
        }
    });

    const total = RATING_KEYS.reduce((sum, k) => sum + distribution[k], 0);

    return RATING_KEYS.map((stars) => ({
        stars,
        count: distribution[stars],
        percentage: total
            ? +((distribution[stars] / total) * 100).toFixed(2)
            : 0,
    }));
};

export const getAverageRating = (reviews: any[]): number => {
    const ratings = reviews.map((review) => review?.rating);
    const total = ratings.reduce((sum, rating) => sum + rating, 0);
    return +(total / ratings.length).toFixed(2);
};
